function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Iconly/Bulk/Logout"
}, /*#__PURE__*/React.createElement("g", {
  id: "Logout"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill 1",
  opacity: 0.4,
  d: "M2 6.447C2 3.996 4.03024 2 6.52453 2H11.4856C13.9748 2 16 3.99 16 6.437V17.553C16 20.005 13.9698 22 11.4744 22H6.51537C4.02515 22 2 20.01 2 17.563V16.623V6.447Z",
  fill: "#FF5B5B"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill 3",
  d: "M21.779 11.455L18.9332 8.54604C18.6391 8.24604 18.1657 8.24604 17.8726 8.54804C17.5804 8.85004 17.5814 9.33704 17.8745 9.63704L19.4338 11.23H17.9388H9.5485C9.13459 11.23 8.79858 11.575 8.79858 12C8.79858 12.426 9.13459 12.77 9.5485 12.77H19.4338L17.8745 14.363C17.5814 14.663 17.5804 15.15 17.8726 15.452C18.0196 15.603 18.2115 15.679 18.4043 15.679C18.5952 15.679 18.7871 15.603 18.9332 15.454L21.779 12.546C21.9202 12.401 22 12.205 22 12C22 11.796 21.9202 11.6 21.779 11.455Z",
  fill: "#FF5B5B"
})));
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.97b04adb.svg";
export { ForwardRef as ReactComponent };